import { modal$ } from '../stores/store-main.js';
import { activeTrackId$ } from '../stores/store-tours.js';
const meterFormat = Intl.NumberFormat('de-CH', {
    style: 'unit',
    unit: 'meter',
    maximumFractionDigits: 0,
});
const kilometerFormat = Intl.NumberFormat('de-CH', {
    style: 'unit',
    unit: 'kilometer',
    maximumFractionDigits: 1,
});
const speedFormat = Intl.NumberFormat('de-CH', {
    style: 'unit',
    unit: 'kilometer-per-hour',
    maximumFractionDigits: 0,
});
const numberFormat = Intl.NumberFormat('de-CH', {
    maximumFractionDigits: 0,
});
export function formatMeter(meters) {
    return meterFormat.format(meters);
}
export function formatAltitude(meters) {
    return numberFormat.format(meters).concat(' ').concat('m.a.s.l.');
}
export function formatKilometer(kilometers) {
    return kilometerFormat.format(kilometers);
}
export function formatMeterOrKilometer(meters) {
    return meters < 1000 ? formatMeter(meters) : formatKilometer(meters / 1000);
}
export function formatSpeed(speed) {
    return speedFormat.format(speed);
}
export const TIME_TYPES = {
    velo: 'bg-cycle-icon',
    e_velo: 'bg-e-cycle-icon',
    wander: 'bg-hike-icon',
    winter_hiking: 'bg-winter-hike-icon',
    snowshoe_trekking: 'bg-snowshoe-icon',
    mountain_biking: 'bg-mountain-bike-icon',
    e_mountain_biking: 'bg-e-mountain-bike-icon',
    canoeing: 'bg-canoe-icon',
    skating: 'bg-skate-icon',
    cross_country_skiing: 'bg-cross-country-icon',
    sledging: 'bg-sledge-icon',
    no: 'bg-no-time-type-icon',
};
export function getTourTime(timetype, meta) {
    let time = 0;
    if (isRecordedTourMeta(meta)) {
        time = meta.trackedTimeTotal;
    }
    else if (isTourMeta(meta)) {
        switch (timetype) {
            case 'velo':
                time = meta.biking;
                break;
            case 'e_velo':
                time = meta.eBiking;
                break;
            case 'winter_hiking':
                time = meta.winterHiking;
                break;
            case 'snowshoe_trekking':
                time = meta.snowshoeTrekking;
                break;
            case 'wander':
                time = meta.walking;
                break;
            case 'mountain_biking':
                time = meta.mountainBiking;
                break;
            case 'e_mountain_biking':
                time = meta.eMountainBiking;
                break;
        }
    }
    return time;
}
export function getTourTimeString(timetype, meta) {
    return formatTime(getTourTime(timetype, meta));
}
export function formatTime(time) {
    if (!time)
        return '-';
    time = Math.floor(time);
    const hours = String(Math.floor(time / 60));
    const minutes = String(time % 60);
    return `${hours.length > 1 ? hours : `0${hours}`}\u2009h ${minutes.length > 1 ? minutes : `0${minutes}`}\u2009min`;
}
export function parseTourDate(track) {
    const date = track.userdate || track.modifiedAt;
    return new Date(date);
}
export function formatTourDate(stringDate) {
    return stringDate ? new Date(stringDate).toLocaleDateString('de-CH') : '-';
}
export function isNormalTour(tour) {
    return tour.type === 'normal';
}
export function isRecordedTour(tour) {
    return tour.type === 'recordedtrack';
}
export function isNormalDetailedTour(trackDetails) {
    return isNormalTour(trackDetails.properties);
}
export function isTourMeta(meta) {
    return meta && meta.biking !== undefined;
}
export function isRecordedTourMeta(meta) {
    return meta === null ? false : !isTourMeta(meta) && !isRoute(meta);
}
export function isRoute(meta) {
    return (meta.biking === undefined &&
        meta.trackedTime === undefined);
}
export function updateScale(x, y, width, height) {
    const ratiosXY = [0, 0.5, 0.33, 0.2, 0.1, 0.05];
    const ratiosMinDist = [0, 2000, 5000, 20000, 100000, Infinity];
    console.assert(ratiosXY.length === ratiosMinDist.length);
    let i;
    const xDomain = x.domain();
    let yDomain = y.domain();
    const padding = (yDomain[1] - yDomain[0]) * 0.1;
    y.domain([yDomain[0] - padding, yDomain[1] + padding]);
    yDomain = y.domain();
    const xMin = xDomain[0];
    const xMax = xDomain[1];
    const yMin = yDomain[0];
    const yMax = yDomain[1];
    let yDomainLength;
    i = 0;
    let reverse = false;
    while (true) {
        if (!reverse && xMax > ratiosMinDist[i]) {
            ++i;
            continue;
        }
        const ratioYOverX = ratiosXY[i];
        const xResolution = (xMax - xMin) / width;
        yDomainLength = ratioYOverX * xResolution * height;
        if (i > 0 && yDomainLength < yMax - yMin) {
            reverse = true;
            --i;
            continue;
        }
        break;
    }
    if (yDomainLength) {
        const yMean = (yMax + yMin) / 2;
        const yHalfDomain = yDomainLength / 2;
        y.domain([yMean - yHalfDomain, yMean + yHalfDomain]).nice();
    }
    if (y.domain()[0] < 0) {
        const shift = 0 - y.domain()[0];
        y.domain([0, y.domain()[1] + shift]).nice();
    }
}
export function placeholderDateNow() {
    const dt = new Date();
    const padFunc = (nr, len = 2, char = '0') => `${nr}`.padStart(len, char);
    const dateNow = `${padFunc(dt.getDate())}.${padFunc(dt.getMonth() + 1)}.${dt.getFullYear()} ${padFunc(dt.getHours())}:${padFunc(dt.getMinutes())}`;
    return `${'Tour'} ${dateNow}`;
}
export function getCopyName(name) {
    const copyName = `${'Copy of '}${name}`;
    if (copyName.length > 40) {
        return copyName.slice(0, 37) + '...';
    }
    return copyName;
}
export function confirmDiscardChanges() {
    return new Promise((resolve) => {
        modal$.next({
            type: 'confirm',
            data: {
                title: activeTrackId$.value
                    ?
                        'Do you want to leave the page without saving the changes to the tour?'
                    : 'Do you want to leave the page without saving the drawn tour?',
                text: 'You are currently drawing a tour and the last changes have not yet been saved. Would you like to finish drawing and save the tour before leaving the page?',
                cancelBtnText: 'Continue drawing',
                confirmBtnText: 'Leave page',
                onCancel: () => resolve(false),
                onConfirm: () => resolve(true),
                onClose: () => resolve(false),
            },
        });
    });
}
//# sourceMappingURL=tours.js.map